module.exports = __webpack_public_path__ + "static/img/blog_lg_landscape.263757f.png";


//////////////////
// WEBPACK FOOTER
// ./src/art/blog_lg_landscape.png
// module id = OkcC
// module chunks = 1